import React, { ReactElement } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import Button from '../../button/Button';
import Modal from '../Modal';

import './save-changes-modal.scss';

type Props = {
  redirectUrl?: string;
  handleSaveClick: () => void;
};

const SaveChangesModal = ({ redirectUrl, handleSaveClick }: Props): ReactElement => {
  const navigate: NavigateFunction = useNavigate();

  return (
    <Modal show={!!redirectUrl}>
      <div className="save-changes-modal" data-testid="save-changes-modal">
        <div className="save-changes-modal__header">
          <p>Save Changes</p>
        </div>
        <p>Would you like to save your changes?</p>
        <div className="save-changes-modal__button-container">
          <Button text="Discard" onClick={(): void => navigate(redirectUrl ?? '')} />
          <Button text="Save" onClick={handleSaveClick} />
        </div>
      </div>
    </Modal>
  );
};

export default SaveChangesModal;
